import ShowCustomReceipt from "./ShowCustomReceipt";
export default ShowCustomReceipt;
